import { createCtx } from "@tiny/utils/react/createContext";
import { DrawerManagerContext } from "./DrawerManager.types";

const [useDrawerManager, DrawerManagerProvider] =
  createCtx<DrawerManagerContext>();

export { useDrawerManager, DrawerManagerProvider };
